import { TPartnerName } from '@partners/api';
import { IFeatureSettings, IPartnerSettings, IThemeSettings, TFeature } from './model';

const DEFAULT_FEATURE_SETTINGS: Partial<IFeatureSettings> = {
  isFooterFixed: false,
  isProgressHidden: false,
  isProgressRendered: true,
  headerCloseAction: 'confirm-exit'
};

export class SettingsMap {
  //#region features-map
  static #features = new Map<TFeature, Partial<IFeatureSettings>>()
    .set('introduction', SettingsMap.create('introduction', { isFooterFixed: true, isProgressRendered: false }))
    .set('welcome', SettingsMap.create('welcome', { isFooterFixed: true, isProgressRendered: false }))
    .set('amount', SettingsMap.create('amount'))
    .set(
      'agreement-indication',
      SettingsMap.create('agreement-indication', {
        path: 'agreement/agreement-indication',
        isFooterFixed: true
      })
    )
    .set(
      'agreement-concent',
      SettingsMap.create('agreement-concent', {
        path: 'agreement/agreement-concent',
        isFooterFixed: true,
        loaderOptions: { send: [{ message: 'אנחנו מסכמים את כל הפרטים שמילאת' }] }
      })
    )
    .set('scan-intro', SettingsMap.create('scan-intro', { path: 'scan/scan-intro' }))
    .set(
      'scan-method',
      SettingsMap.create('scan-method', {
        path: 'scan/scan-method'
      })
    )
    .set(
      'scan-details',
      SettingsMap.create('scan-details', {
        path: 'scan/scan-details',
        isFooterFixed: true
      })
    )
    .set(
      'scan-document',
      SettingsMap.create('scan-document', {
        path: 'scan/scan-document',
        isFooterFixed: true,
        loaderOptions: { send: [{ message: 'אנחנו בודקים את התעודה' }] }
      })
    )
    .set('scan-gender', SettingsMap.create('scan-gender', { path: 'scan/scan-gender', isFooterFixed: true }))
    .set(
      'scan-preview',
      SettingsMap.create('scan-preview', {
        path: 'scan/scan-preview',
        isFooterFixed: true
      })
    )
    .set('classify', SettingsMap.create('classify', { isProgressRendered: false }))
    .set('offer', SettingsMap.create('offer', { isProgressRendered: false }))
    .set(
      'identity',
      SettingsMap.create('identity', {
        loaderOptions: { send: [{ message: 'כמה רגעים, אנחנו רק בודקים את הפרטים' }] }
      })
    )
    .set('auth-guide', SettingsMap.create('auth-guide', { isProgressRendered: false }))
    .set('auth-otp', SettingsMap.create('auth-otp', { path: 'authentication/auth-otp', isProgressRendered: false }))
    .set(
      'auth-login',
      SettingsMap.create('auth-login', { path: 'authentication/auth-login', isProgressRendered: false })
    )
    .set('contact', SettingsMap.create('contact'))
    .set(
      'debits',
      SettingsMap.create('debits', {
        loaderOptions: { send: [{ message: 'מצוין, מיד נמשיך' }] }
      })
    )
    .set(
      'card',
      SettingsMap.create('card', {
        loaderOptions: {
          send: [{ message: 'אנחנו מסכמים את כל הפרטים שמילאת' }]
        }
      })
    )
    .set('delivery', SettingsMap.create('delivery'))
    .set(
      'privacy',
      SettingsMap.create('privacy', {
        isFooterFixed: true
      })
    )
    .set(
      'proposal',
      SettingsMap.create('proposal', {
        loaderOptions: {
          load: [
            {
              duration: 6000,
              message: 'אנחנו מסכמים את כל הפרטים שמילאת',
              animation: 'assets/animations/loader_white_01.json'
            },
            {
              message: 'לא לסגור, אנחנו תיכף מסיימים',
              animation: 'assets/animations/loader_white_02.json'
            }
          ]
        }
      })
    )
    .set('address', SettingsMap.create('address'))
    .set('persona', SettingsMap.create('persona'))
    .set('purpose', SettingsMap.create('purpose'))
    .set('simulator', SettingsMap.create('simulator'))
    .set('employment', SettingsMap.create('employment'))
    .set('marital', SettingsMap.create('marital'))
    .set('online-use', SettingsMap.create('online-use'))
    .set('refused', SettingsMap.create('refused'))
    .set('expense', SettingsMap.create('expense'))
    .set('income', SettingsMap.create('income'))
    .set('country', SettingsMap.create('country'))
    .set('account', SettingsMap.create('account'))
    .set(
      'composedoc',
      SettingsMap.create('composedoc', {
        path: 'signature/composedoc'
      })
    )
    .set(
      'signature',
      SettingsMap.create('signature', {
        loaderOptions: {
          send: [{ message: 'אנחנו שומרים את המסמכים, כמה שניות וזהו' }],
          load: [{ message: 'נהדר! אנחנו מתקרבים לסיום' }]
        }
      })
    )
    .set('issue', SettingsMap.create('issue', { isProgressRendered: false }))
    .set('beneficiaries', SettingsMap.create('beneficiaries'))
    .set('demography', SettingsMap.create('demography'))
    .set('disclosure', SettingsMap.create('disclosure', { isFooterFixed: true }))
    .set('lead', SettingsMap.create('lead', { isFooterFixed: true }))
    .set(
      'summary',
      SettingsMap.create('summary', {
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'alert',
      SettingsMap.create('alert', {
        path: 'message/alert',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'guide',
      SettingsMap.create('guide', {
        path: 'message/guide',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'confirm',
      SettingsMap.create('confirm', {
        path: 'message/confirm',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'cvv-guide',
      SettingsMap.create('cvv-guide', {
        path: 'message/guide/cvv',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'persona-guide',
      SettingsMap.create('persona-guide', {
        path: 'message/guide/persona',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'card-type-guide',
      SettingsMap.create('card-type-guide', {
        path: 'message/guide/card-type',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'credit-line-guide',
      SettingsMap.create('credit-line-guide', {
        path: 'message/guide/credit-line',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'scan-validate-alert',
      SettingsMap.create('scan-validate-alert', {
        path: 'message/alert/scan-validate',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'partner-summary-alert',
      SettingsMap.create('partner-summary-alert', {
        path: 'message/alert/partner-summary',
        headerCloseAction: 'direct-exit',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'generic-alert',
      SettingsMap.create('generic-alert', {
        path: 'message/alert/generic',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'bdi-alert',
      SettingsMap.create('bdi-alert', {
        path: 'message/alert/bdi',
        headerCloseAction: 'direct-exit',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'loan-amount-refused-alert',
      SettingsMap.create('loan-amount-refused-alert', {
        path: 'message/alert/loan-amount-refused-alert',
        headerCloseAction: 'direct-exit',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'add-card-to-wallet-alert',
      SettingsMap.create('add-card-to-wallet-alert', {
        path: 'message/alert/add-card-to-wallet',
        headerCloseAction: 'direct-exit',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'identity-validation-alert',
      SettingsMap.create('identity-validation-alert', {
        path: 'message/alert/identity-validation',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'card-quota-alert',
      SettingsMap.create('card-quota-alert', {
        path: 'message/alert/card-quota',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'account-verification-alert',
      SettingsMap.create('account-verification-alert', {
        path: 'message/alert/account-verification',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'exit-confirm',
      SettingsMap.create('exit-confirm', {
        path: 'message/confirm/exit',
        headerCloseAction: 'move-previous',
        isFooterFixed: true,
        isProgressRendered: false
      })
    )
    .set(
      'opt-out-otp-confirm',
      SettingsMap.create('opt-out-otp-confirm', {
        path: 'message/confirm/opt-out-otp',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'confirm-exit'
      })
    )

    .set(
      'failed-scan-attempt-alert',
      SettingsMap.create('failed-scan-attempt-alert', {
        path: 'message/alert/failed-scan-attempt',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'no-document-to-scan-alert',
      SettingsMap.create('no-document-to-scan-alert', {
        path: 'message/alert/no-document-to-scan',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'move-previous'
      })
    )
    .set(
      'old-identification-card-alert',
      SettingsMap.create('old-identification-card-alert', {
        path: 'message/alert/old-identification-card',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'card-identification-alert',
      SettingsMap.create('card-identification-alert', {
        path: 'message/alert/card-identification-alert',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'invalid-issue-date-alert',
      SettingsMap.create('invalid-issue-date-alert', {
        path: 'message/alert/invalid-issue-date-alert',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'debit-card-alert',
      SettingsMap.create('debit-card-alert', {
        path: 'message/alert/debit-card-alert',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'cal-card-alert',
      SettingsMap.create('cal-card-alert', {
        path: 'message/alert/cal-card-alert',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'card-verification-alert',
      SettingsMap.create('card-verification-alert', {
        path: 'message/alert/card-verification-alert',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'agreement-consent-confirm',
      SettingsMap.create('agreement-consent-confirm', {
        path: 'message/confirm/agreement-consent-confirm',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'direct-exit'
      })
    )
    .set(
      'document-upload-format-alert',
      SettingsMap.create('document-upload-format-alert', {
        path: 'message/alert/document-upload-format',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'move-previous'
      })
    )
    .set(
      'document-upload-alert',
      SettingsMap.create('document-upload-alert', {
        path: 'message/alert/document-upload',
        isFooterFixed: true,
        isProgressRendered: false,
        headerCloseAction: 'move-previous'
      })
    );
  //#endregion

  /**
   * @description
   * creates a settings node for a feature. requires a feature name & feature's path as minimum
   * arguments
   * @param name feature's name
   * @param options feature's settings options
   * @returns a full feature settings node
   */
  static create(name: TFeature, options: Partial<IFeatureSettings> = null): IFeatureSettings {
    options = { ...DEFAULT_FEATURE_SETTINGS, ...options };
    return Object.assign(
      {
        name: name,
        path: options?.path ?? `${name}`
      },
      { ...options }
    );
  }

  /**
   * a local map of logo settings for each partner. settings can dictate the logo's mode (default|alt)
   * or hide|show the primary|secondary logo.
   * (1) primary: visibility of primary logo (the centered header logo). omitted means visible.
   * (2) secondary: visibility of secondary logo (the right-aligned header logo - usually cal logo). omitted means visible.
   * (3) mode + process: source oof the asset match logo source logo to the process identity name
   */
  static #theme = new Map<TPartnerName, IThemeSettings>()
    .set('cal', { isPrimaryLogoVisible: false })
    .set('cal-loan', { isPrimaryLogoVisible: false })
    .set('hashkal', { isPrimaryLogoVisible: false })
    .set('becal', { isPrimaryLogoVisible: false })
    .set('family365', { logoSource: 'alt', logoSourceMatch: 'loan', iconSet: 'outlined' })
    .set('flycard', { logoSource: 'alt', logoSourceMatch: 'loan', iconSet: 'outlined' })
    .set('powercard', { logoSource: 'alt', logoSourceMatch: 'loan', iconSet: 'outlined' })
    .set('shufersal', { logoSource: 'alt', logoSourceMatch: 'loan', iconSet: 'outlined' })
    .set('mami', { iconSet: 'outlined' })
    .set('htzone', { iconSet: 'outlined' })
    .set('hitechzone-cashback', { iconSet: 'outlined' })
    .set('students', { iconSet: 'outlined' })
    .set('idf', { iconSet: 'outlined' })
    .set('cibus', { iconSet: 'outlined', isPrimaryLogoVisible: false })
    .set('payme', { iconSet: 'outlined' })
    .set('yenotbitan', { iconSet: 'outlined' })
    .set('wix', { iconSet: 'outlined' })
    .set('carrefour', { iconSet: 'custom' })
    .set('matalon', { isPrimaryLogoVisible: false })
    .set('paylease', { isPrimaryLogoVisible: false })
    .set('hando', { iconSet: 'outlined' })
    .set('secret-flights', { isPrimaryLogoVisible: true })
    .set('bttr', { iconSet: 'outlined' });

  static themeSettings(partner: TPartnerName): IThemeSettings | undefined {
    return {
      iconSet: 'filled',
      ...SettingsMap.#theme.get(partner)
    };
  }
  static #partner = new Map<TPartnerName, IPartnerSettings>().set('paybox', { useHistoryForPartnerUpdates: true });

  static partnerSettings(partnerName: TPartnerName): IPartnerSettings {
    return SettingsMap.#partner.get(partnerName);
  }
  /**
   * @description
   * implicitly get a feature's settings via feature's name
   * @param name feature's name
   * @returns feature's settings node
   */
  static get(name: TFeature): IFeatureSettings {
    return SettingsMap.#features.get(name) as IFeatureSettings;
  }
  static introduction(): IFeatureSettings {
    return SettingsMap.get('introduction');
  }
  static welcome(): IFeatureSettings {
    return SettingsMap.get('welcome');
  }
  static simulator(): IFeatureSettings {
    return SettingsMap.get('simulator');
  }
  static identity(): IFeatureSettings {
    return SettingsMap.get('identity');
  }
  static classify(): IFeatureSettings {
    return SettingsMap.get('classify');
  }
  static offer(): IFeatureSettings {
    return SettingsMap.get('offer');
  }
  static scanIntro(): IFeatureSettings {
    return SettingsMap.get('scan-intro');
  }
  static scanMethod(): IFeatureSettings {
    return SettingsMap.get('scan-method');
  }
  static scanGender(): IFeatureSettings {
    return SettingsMap.get('scan-gender');
  }
  static scanDocument(): IFeatureSettings {
    return SettingsMap.get('scan-document');
  }
  static scanDetails(): IFeatureSettings {
    return SettingsMap.get('scan-details');
  }
  static scanPreview(): IFeatureSettings {
    return SettingsMap.get('scan-preview');
  }
  static contact(): IFeatureSettings {
    return SettingsMap.get('contact');
  }
  static card(): IFeatureSettings {
    return SettingsMap.get('card');
  }
  static privacy(): IFeatureSettings {
    return SettingsMap.get('privacy');
  }
  static address(): IFeatureSettings {
    return SettingsMap.get('address');
  }
  static employment(): IFeatureSettings {
    return SettingsMap.get('employment');
  }
  static purpose(): IFeatureSettings {
    return SettingsMap.get('purpose');
  }
  static authGuide(): IFeatureSettings {
    return SettingsMap.get('auth-guide');
  }
  static authOtp(): IFeatureSettings {
    return SettingsMap.get('auth-otp');
  }
  static authLogin(): IFeatureSettings {
    return SettingsMap.get('auth-login');
  }
  static persona(): IFeatureSettings {
    return SettingsMap.get('persona');
  }
  static beneficiaries(): IFeatureSettings {
    return SettingsMap.get('beneficiaries');
  }
  static signature(): IFeatureSettings {
    return SettingsMap.get('signature');
  }
  static composedoc(): IFeatureSettings {
    return SettingsMap.get('composedoc');
  }
  static issue(): IFeatureSettings {
    return SettingsMap.get('issue');
  }
  static debits(): IFeatureSettings {
    return SettingsMap.get('debits');
  }
  static income(): IFeatureSettings {
    return SettingsMap.get('income');
  }
  static country(): IFeatureSettings {
    return SettingsMap.get('country');
  }
  static amount(): IFeatureSettings {
    return SettingsMap.get('amount');
  }
  static account(): IFeatureSettings {
    return SettingsMap.get('account');
  }
  static disclosure(): IFeatureSettings {
    return SettingsMap.get('disclosure');
  }
  static proposal(): IFeatureSettings {
    return SettingsMap.get('proposal');
  }
  static agreementIndication(): IFeatureSettings {
    return SettingsMap.get('agreement-indication');
  }
  static agreementConsent(): IFeatureSettings {
    return SettingsMap.get('agreement-concent');
  }
  static agreementConsentConfirm(): IFeatureSettings {
    return SettingsMap.get('agreement-consent-confirm');
  }
  static alert(): IFeatureSettings {
    return SettingsMap.get('alert');
  }
  static guide(): IFeatureSettings {
    return SettingsMap.get('guide');
  }
  static confirm(): IFeatureSettings {
    return SettingsMap.get('confirm');
  }
  static cvvGuide(): IFeatureSettings {
    return SettingsMap.get('cvv-guide');
  }
  static cardTypeGuide(): IFeatureSettings {
    return SettingsMap.get('card-type-guide');
  }
  static creditLineGuide(): IFeatureSettings {
    return SettingsMap.get('credit-line-guide');
  }
  static personaGuide(): IFeatureSettings {
    return SettingsMap.get('persona-guide');
  }
  static bdiAlert(): IFeatureSettings {
    return SettingsMap.get('bdi-alert');
  }
  static identityValidationAlert(): IFeatureSettings {
    return SettingsMap.get('identity-validation-alert');
  }
  static cardQuotaAlert(): IFeatureSettings {
    return SettingsMap.get('card-quota-alert');
  }
  static accountVerificationAlert(): IFeatureSettings {
    return SettingsMap.get('account-verification-alert');
  }
  static scanValidateAlert(): IFeatureSettings {
    return SettingsMap.get('scan-validate-alert');
  }
  static exitConfirm(): IFeatureSettings {
    return SettingsMap.get('exit-confirm');
  }
  static optOutOtpConfirm(): IFeatureSettings {
    return SettingsMap.get('opt-out-otp-confirm');
  }
  static expense(): IFeatureSettings {
    return SettingsMap.get('expense');
  }
  static marital(): IFeatureSettings {
    return SettingsMap.get('marital');
  }
  static lead(): IFeatureSettings {
    return SettingsMap.get('lead');
  }
  static delivery(): IFeatureSettings {
    return SettingsMap.get('delivery');
  }
  static summary(): IFeatureSettings {
    return SettingsMap.get('summary');
  }
  static demography(): IFeatureSettings {
    return SettingsMap.get('demography');
  }
  static onlineUse(): IFeatureSettings {
    return SettingsMap.get('online-use');
  }
  static refused(): IFeatureSettings {
    return SettingsMap.get('refused');
  }
  static failedScanAttemptAlert(): IFeatureSettings {
    return SettingsMap.get('failed-scan-attempt-alert');
  }
  static noDocumentToScanAlert(): IFeatureSettings {
    return SettingsMap.get('no-document-to-scan-alert');
  }
  static oldIdentificationCardAlert(): IFeatureSettings {
    return SettingsMap.get('old-identification-card-alert');
  }
  static cardIdentificationAlert(): IFeatureSettings {
    return SettingsMap.get('card-identification-alert');
  }
  static invalidIssueDateAlert(): IFeatureSettings {
    return SettingsMap.get('invalid-issue-date-alert');
  }
  static debitCardAlertComponent(): IFeatureSettings {
    return SettingsMap.get('debit-card-alert');
  }
  static calCardAlert(): IFeatureSettings {
    return SettingsMap.get('cal-card-alert');
  }
  static cardVerificationAlert(): IFeatureSettings {
    return SettingsMap.get('card-verification-alert');
  }
  static genericAlert(): IFeatureSettings {
    return SettingsMap.get('generic-alert');
  }
  static partnerSummaryAlert(): IFeatureSettings {
    return SettingsMap.get('partner-summary-alert');
  }
  static documentUploadFormatAlert(): IFeatureSettings {
    return SettingsMap.get('document-upload-format-alert');
  }
  static documentUploadAlert(): IFeatureSettings {
    return SettingsMap.get('document-upload-alert');
  }
  static loanAmountRefused(): IFeatureSettings {
    return SettingsMap.get('loan-amount-refused-alert');
  }
  static addCardToWalletAlert(): IFeatureSettings {
    return SettingsMap.get('add-card-to-wallet-alert');
  }
}
